import { render, staticRenderFns } from "./branch-autocomplete.vue?vue&type=template&id=7ff89f4d&scoped=true&"
import script from "./branch-autocomplete.vue?vue&type=script&lang=js&"
export * from "./branch-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff89f4d",
  null
  
)

export default component.exports